<template>
  <div class="main-weibo">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <el-row>
          <el-col :span="4">
            <span style="font-size: 24px">{{ $t('工程动态.工程动态') }}</span>
          </el-col>
          <el-col :span="16">
            <el-row>
              <el-col :span="12">
                <el-date-picker v-model="timeRange" type="datetimerange" :picker-options="pickerOptions"
                  :range-separator="$t('工程动态.至')" :start-placeholder="$t('工程动态.开始日期')"
                  :end-placeholder="$t('工程动态.结束日期')" align="right" @change="GetProweiboList"></el-date-picker>
              </el-col>
              <el-col :span="12">
                <el-select style="width: 90%" clearable v-model="weiboLabelValue" multiple
                  :placeholder="$t('工程动态.请选择动态标签')" @change="GetProweiboList">
                  <el-option v-for="item in weiboLabel" :key="item.pwst01" :label="item.pwst03"
                    :value="item.pwst03"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <el-select style="width: 90%" v-model="fenleiValue" @change="changeFenLei" :placeholder="$t('工程动态.请选择分类')">
              <el-option v-for="item in fenleiArr" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <el-container class="myContainer">
        <el-aside width="200px" style="
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            text-align: center;
          " class="elAside">
          <el-button type="primary" size="small" @click="uploadWeibo">{{ $t('工程动态.发布动态') }}</el-button>
          <div class="zTreeDiv">
            <ul id="weiboTree" class="ztree"></ul>
          </div>
        </el-aside>
        <el-main style="margin-left: 10px">
          <el-row>
            <el-col style="margin-bottom: 20px; padding-right: 20px" :span="12" v-for="(item, index) in weiboList"
              :key="index">
              <div class="weiboItem">
                <el-card style="height: 200px">
                  <el-row :gutter="60" style="border-bottom: 1px solid #eee">
                    <el-col :span="2">
                      <el-image style="width: 50px; height: 50px" :src="$store.state.baseUrl + item.user13"
                        fit="fill"></el-image>
                    </el-col>
                    <el-col :span="18" style="height: 50px">
                      <el-row>
                        <el-col style="
                            height: 25px;
                            line-height: 25px;
                            overflow: hidden;
                          " :span="4">{{ item.user04 }}</el-col>
                        <el-col :span="4" v-for="(item2, index2) in item.prwb03 == null
                          ? []
                          : item.prwb03.split(',')" :key="index2">
                          <div style="
                              height: 20px;
                              background: rgb(230 162 60);
                              text-align: center;
                              border-radius: 4px;
                              margin-right: 5px;
                              color: #fff;
                            ">
                            {{ item2 }}
                          </div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6" style="color: #666; font-size: 12px">
                          {{ item.prwb05 }}
                        </el-col>
                        <el-col :span="10" :offset="3" style="
                            font-weight: 700;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          " :title="item.prwb08">{{ item.prwb08 }}
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="2">
                      <el-button v-if="item.isShow" type="danger" size="small" icon="el-icon-delete"
                        @click="DelWeiBo(item)"></el-button>
                    </el-col>
                  </el-row>
                  <div @click="showWeiboContent(item)" v-html="item.prwb04" style="height: 120px; overflow: auto">
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
          <div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" align="center"
              style="margin-top: 30px" :current-page="pageIndex" :page-sizes="[10, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-card>

    <!-- 发布动态 -->
    <el-dialog :close-on-click-modal="false" :title="$t('工程动态.动态')" :visible.sync="weiboDialogVisible" width="80%">
      <el-input :placeholder="$t('工程动态.请输入标题')" v-model="weiboTitle"></el-input>
      <ckediter4 ref="ck" v-model="weiboValue"></ckediter4>

      <div v-if="weiboDialogVisible2">
        <el-select style="width: 30%; margin-right: 5%; margin-top: 20px" v-model="weiboLabelValue1" multiple
          :placeholder="$t('工程动态.请选择动态标签')">
          <el-option v-for="item in weiboLabel" :key="item.pwst01" :label="item.pwst03"
            :value="item.pwst03"></el-option>
        </el-select>
        <!-- 添加时间 -->
        <el-date-picker style="width: 30%; margin-right: 5%" type="datetime" v-model="prwb05"
          :placeholder="$t('工程动态.选择日期时间')"></el-date-picker>
        <el-select style="width: 30%" v-model="fenleiValue1" :placeholder="$t('工程动态.请选择分类')">
          <el-option v-for="item in fenleiArr" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </div>
      <span v-if="weiboDialogVisible2" slot="footer" class="dialog-footer">
        <el-button @click="weiboDialogVisible = false">{{ $t('工程动态.取消') }}</el-button>
        <el-button type="primary" @click="upload">{{ $t('工程动态.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetDeptWithUser,
  GetPweiboSetList,
  GetProweiboList,
  DelWeiBo,
  AddWeiBo,
} from "@/setAxios";
import ckediter4 from "@/components/ck.vue";
export default {
  name: "weibo",
  components: { ckediter4 },
  data() {
    return {
      prwb05: new Date(),
      menuData: [],
      weiboLabel: [],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('工程动态.最近一周'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t('工程动态.最近一个月'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t('工程动态.最近三个月'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      timeRange: [],
      uids: "",
      zTeeObj: null,
      weiboLabelValue: "",
      weiboLabelValue1: "", //发布选择标签值
      fenleiValue: 1,
      fenleiValue1: 1, //发布选择标类别
      fenleiArr: [
        {
          id: 1,
          label: this.$t('工程动态.公开'),
        },
        {
          id: 2,
          label: this.$t('工程动态.私人'),
        },
      ],
      weiboDialogVisible: false,
      weiboValue: "",
      pageIndex: 1,
      pageSize: 10,
      weiboList: [],
      total: 0,
      prwb07: 1, //1共有 2私有
      weiboTitle: "",
      weiboDialogVisible2: false,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    // prwb05() {
    //   this.weiboTitle =
    //     dayjs(this.prwb05).format("YYYY/MM/DD HH:mm") + this.weiboLabelValue1;
    // },
    // weiboLabelValue1() {
    //   this.weiboTitle =
    //     dayjs(this.prwb05).format("YYYY/MM/DD HH:mm") + this.weiboLabelValue1;
    // },
  },
  methods: {
    showWeiboContent(data) {
      this.weiboDialogVisible = true;
      this.weiboDialogVisible2 = false;
      this.weiboValue = data.prwb04;
      this.weiboTitle = data.prwb08;
    },
    //删除动态
    DelWeiBo(data) {
      let params = {
        pwid: data.prwb01,
        uid: localStorage.id,
      };
      DelWeiBo(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('工程动态.成功'),
          });
          this.pageIndex = 1;
          this.GetProweiboList();
        }
      });
    },
    changeFenLei(data) {
      if (data == 1) {
        this.uids = "null";
        this.prwb07 = 1;
      } else {
        this.uids = localStorage.id;
        this.prwb07 = 2;
      }
      this.GetProweiboList();
    },
    // 获取所有数据
    getData() {
      this.GetDeptWithUser();
      this.GetPweiboSetList();
    },
    async GetProweiboList() {
      let params = {
        xid: localStorage.xid,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        uids: this.uids,
        time: this.timeRange,
        prwb07: this.prwb07,
        types: this.weiboLabelValue.join(","),
      };
      let res = await GetProweiboList(params);
      this.weiboList = res.Data.list;
      this.weiboList.forEach((v) => {
        if (v.prwb06 == localStorage.id) v.isShow = true;
      });
      this.total = res.Data.total;
    },
    async GetPweiboSetList() {
      let params = { xid: localStorage.xid };
      let res = await GetPweiboSetList(params);
      this.weiboLabel = res.Data;
    },
    GetDeptWithUser() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetDeptWithUser(params).then((res) => {
        this.menuData = res.Data;
        this.menuData.forEach((v) => {
          v.name = v.prde03;
          v.iconSkin = "dIcon01";
          if (v.children.length > 0) {
            v.children.forEach((v) => {
              v.iconSkin = "dIcon02";
              v.name = v.user04;
            });
          } else {
            delete v.children;
          }
        });
        this.init();
      });
    },
    uploadWeibo() {
      this.weiboDialogVisible = true;
      this.weiboDialogVisible2 = true;
    },
    // 上传动态
    async upload() {
      let prwb03 = this.weiboLabelValue1;
      if (this.fenleiValue1 == 2) {
        prwb03.push("私人");
      }
      prwb03 = prwb03.join(",");

      if (!this.prwb05) {
        this.$message.error(this.$t('工程动态.请选择时间'));
        return;
      }
      if (!this.weiboTitle) {
        this.$message.error(this.$t('工程动态.请输入标题'));
        return;
      }
      if (!this.$refs.ck.ckeditor.getData()) {
        this.$message.error(this.$t('工程动态.请输入内容'));
        return;
      }
      let params = {
        prwb01: 0,
        prwb02: localStorage.xid,
        prwb03: prwb03,
        prwb04: this.$refs.ck.ckeditor.getData(),
        prwb05: this.prwb05,
        prwb06: localStorage.id,
        prwb07: this.fenleiValue1,
        prwb08: this.weiboTitle,
      };

      let res = await AddWeiBo(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('工程动态.成功'),
        });
        this.weiboDialogVisible = false;
        this.GetProweiboList();
      } else {
        å;
        this.$message({
          type: "error",
          message: this.$t('工程动态.失败'),
        });
      }
    },
    //初始化ztree
    init() {
      var _this = this;

      var selectNode;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "name",
          },
          simpleData: {
            enable: true,
            idKey: "prde01",
            pIdKey: "prde07",
          },
        },
        callback: {
          onClick: onclick,
          onCheck: onCheck,
        },
      };
      this.zTeeObj = $.fn.zTree.init($("#weiboTree"), setting, this.menuData);

      this.zTeeObj.checkAllNodes(true);

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.uids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        if (element.user01) {
          _this.uids += _split + element.user01;
          _split = ",";
        }
      });
      _this.GetProweiboList();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.uids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          if (element.user01) {
            _this.uids += _split + element.user01;
            _split = ",";
          }
        });
        _this.GetProweiboList();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.uids = treeNode.user01 ? treeNode.user01 : _this.uids;
        _this.pagenum = 1;
        _this.GetProweiboList();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetProweiboList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetProweiboList();
    },
  },
};
</script>

<style lang="less" scoped>
.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

.myContainer {
  width: 100%;
  height: 80vh;

  .elAside {
    border-right: 1px dashed #eee;
  }
}

/deep/ .ztree li span.button.dIcon01_ico_open,
/deep/ .ztree li span.button.button.dIcon01_ico_close,
/deep/ .ztree li span.button.dIcon01_ico_docu {
  margin-right: 2px;
  background: url("../../../assets/img/bumen.png") no-repeat scroll 0 0 transparent;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

.myContainer {
  width: 100%;
  height: 80vh;

  .elAside {
    border-right: 1px dashed #eee;
  }
}

/deep/ .ztree li span.button.dIcon01_ico_open,
/deep/ .ztree li span.button.button.dIcon01_ico_close,
/deep/ .ztree li span.button.dIcon01_ico_docu {
  margin-right: 2px;
  background: url("../../../assets/img/bumen.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.dIcon02_ico_open,
/deep/ .ztree li span.button.button.dIcon02_ico_close,
/deep/ .ztree li span.button.dIcon02_ico_docu {
  margin-right: 2px;
  background: url("../../../assets/img/weiboren.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}
</style>
